/* Honey Peak Quiz — behaviour for sections/honey-peak-quiz.liquid
   Every step is a block in the theme editor. Steps run in the order the blocks
   are arranged; nothing here needs editing when content changes. */
(function () {
  'use strict';

  var instances = {};

  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function easeOutCubic(p) { return 1 - Math.pow(1 - p, 3); }

  function HoneyPeakQuiz(root) {
    this.root = root;
    this.steps = Array.prototype.slice.call(root.querySelectorAll('[data-hpq-step]'));
    this.current = 0;
    this.history = [0];
    this.timers = [];
    this.intervals = [];
    this.loadingPhase = 0;
    this.loadingStep = null;
    this.redirectUrl = root.getAttribute('data-redirect') || '';
    this.designMode = root.getAttribute('data-design-mode') === 'true' ||
      !!(window.Shopify && window.Shopify.designMode);

    this.progressBar = root.querySelector('[data-hpq-progress]');
    this.backBtn = root.querySelector('[data-hpq-back]');
    this.counter = root.querySelector('[data-hpq-counter]');
    this.qCurrent = root.querySelector('[data-hpq-current]');
    this.qTotal = root.querySelector('[data-hpq-total]');
    this.modal = root.querySelector('[data-hpq-modal]');
    this.modalText = root.querySelector('[data-hpq-modal-text]');

    this.counted = this.steps.filter(function (s) { return s.getAttribute('data-counted') === 'true'; });

    this.onClick = this.onClick.bind(this);
    this.onKey = this.onKey.bind(this);
    root.addEventListener('click', this.onClick);
    root.addEventListener('keydown', this.onKey);

    this.initSliders();
    if (this.steps.length) this.show(0, false);
  }

  HoneyPeakQuiz.prototype.later = function (fn, ms) {
    var t = setTimeout(fn, ms);
    this.timers.push(t);
    return t;
  };

  HoneyPeakQuiz.prototype.destroy = function () {
    this.timers.forEach(clearTimeout);
    this.intervals.forEach(clearInterval);
    this.root.removeEventListener('click', this.onClick);
    this.root.removeEventListener('keydown', this.onKey);
  };

  /* ====== NAV ====== */
  HoneyPeakQuiz.prototype.show = function (index, scroll) {
    var n = this.steps.length;
    if (index < 0 || index >= n) return;
    this.steps.forEach(function (s, i) { s.classList.toggle('active', i === index); });
    this.current = index;
    var step = this.steps[index];

    if (this.progressBar) this.progressBar.style.width = Math.round(((index + 1) / n) * 100) + '%';
    if (this.backBtn) this.backBtn.style.display = index !== 0 ? 'block' : 'none';
    if (scroll !== false) window.scrollTo({ top: 0, behavior: 'smooth' });

    this.root.classList.toggle('amq-final', step.hasAttribute('data-final-bg'));
    this.updateCounter(step);

    var type = step.getAttribute('data-type');
    if (type === 'social_proof') this.runSocialProofCount(step);
    if (type === 'summary') this.startSummaryLoading(step);
    if (type === 'plan_chart') this.startChartGrow(step);
    if (type === 'loading') this.startLoadingSequence(step);
    else if (this.modal) this.modal.classList.remove('active');
  };

  HoneyPeakQuiz.prototype.goTo = function (index) {
    if (index >= this.steps.length) { this.submit(); return; }
    this.history.push(index);
    this.show(index);
  };

  HoneyPeakQuiz.prototype.next = function () { this.goTo(this.current + 1); };

  HoneyPeakQuiz.prototype.back = function () {
    if (this.history.length > 1) {
      this.history.pop();
      this.show(this.history[this.history.length - 1]);
    }
  };

  HoneyPeakQuiz.prototype.updateCounter = function (step) {
    if (!this.counter) return;
    var idx = this.counted.indexOf(step);
    if (idx === -1) { this.counter.style.display = 'none'; return; }
    this.counter.style.display = 'block';
    if (this.qCurrent) this.qCurrent.textContent = pad2(idx + 1);
    if (this.qTotal) this.qTotal.textContent = pad2(this.counted.length);
  };

  HoneyPeakQuiz.prototype.submit = function () {
    if (this.designMode) return; /* never leave the theme editor */
    if (this.redirectUrl) window.location.href = this.redirectUrl;
  };

  /* ====== CLICKS ====== */
  HoneyPeakQuiz.prototype.onKey = function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest('.age-card, .option-item');
    if (!el || !this.root.contains(el)) return;
    e.preventDefault();
    el.click();
  };

  HoneyPeakQuiz.prototype.onClick = function (e) {
    var self = this;
    var t = e.target;

    if (t.closest('[data-hpq-back]')) { this.back(); return; }
    if (t.closest('[data-hpq-modal-close]')) { this.closeModal(); return; }
    if (t.closest('[data-hpq-next]')) { this.next(); return; }

    var card = t.closest('.age-card');
    if (card && this.root.contains(card)) {
      var cards = card.parentElement.querySelectorAll('.age-card');
      for (var i = 0; i < cards.length; i++) cards[i].classList.remove('selected');
      card.classList.add('selected');
      this.later(function () { self.next(); }, 350);
      return;
    }

    var opt = t.closest('.option-item');
    if (opt && this.root.contains(opt)) {
      var step = opt.closest('[data-hpq-step]');
      if (step && step.getAttribute('data-type') === 'multi_choice') {
        opt.classList.toggle('selected');
        var any = opt.parentElement.querySelector('.option-item.selected');
        var btn = step.querySelector('[data-hpq-multi-continue]');
        if (btn) btn.classList.toggle('visible', !!any);
        return;
      }
      var items = opt.parentElement.querySelectorAll('.option-item');
      for (var j = 0; j < items.length; j++) items[j].classList.remove('selected');
      opt.classList.add('selected');
      this.later(function () { self.next(); }, 350);
    }
  };

  /* ====== SOCIAL PROOF COUNT-UP ====== */
  HoneyPeakQuiz.prototype.runSocialProofCount = function (step) {
    var el = step.querySelector('.amq-count-num[data-target]');
    if (!el) return; /* animation turned off in the theme editor: number stays static */
    var raw = (el.getAttribute('data-target') || '').trim();
    var m = raw.match(/^([^0-9]*)([0-9][0-9.,]*)(.*)$/);
    if (!m) { el.textContent = raw; return; }
    var before = m[1], num = m[2], after = m[3];
    var fmt;
    var target;
    var grouped = num.match(/^\d{1,3}(([.,])\d{3})+$/);
    if (grouped) {
      /* thousands separators, e.g. 135,115 or 135.115 */
      var sep = grouped[2];
      target = parseInt(num.replace(/[.,]/g, ''), 10);
      fmt = function (v) { return String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    } else {
      /* plain or decimal number, e.g. 1.4, 1,4 or 43100 */
      var decSep = num.indexOf(',') !== -1 ? ',' : '.';
      var parts = num.split(decSep);
      var decimals = parts.length > 1 ? parts[parts.length - 1].length : 0;
      target = parseFloat(num.replace(',', '.'));
      fmt = function (v) { return v.toFixed(decimals).replace('.', decSep); };
    }
    if (isNaN(target)) { el.textContent = raw; return; }

    /* Lock the width to the final number so the heading never reflows while counting */
    el.style.minWidth = '';
    el.textContent = raw;
    var finalWidth = el.getBoundingClientRect().width;
    el.style.minWidth = Math.ceil(finalWidth) + 'px';
    el.style.textAlign = 'right';

    var heading = el.parentElement;
    heading.classList.remove('amq-counting');
    void heading.offsetWidth; /* restart animation */
    heading.classList.add('amq-counting');

    if (this.countFrame) cancelAnimationFrame(this.countFrame);
    var self = this;
    var startTime = null;
    var duration = 1600;
    function tick(now) {
      if (startTime === null) startTime = now;
      var p = Math.min((now - startTime) / duration, 1);
      if (p < 1) {
        el.textContent = before + fmt(target * easeOutCubic(p)) + after;
        self.countFrame = requestAnimationFrame(tick);
      } else {
        el.textContent = raw;
        el.style.minWidth = '';
        el.style.textAlign = '';
        self.countFrame = null;
      }
    }
    this.countFrame = requestAnimationFrame(tick);
  };

  /* ====== TESTIMONIAL SLIDER — 3-card scale carousel ====== */
  HoneyPeakQuiz.prototype.initSliders = function () {
    var self = this;
    var stages = this.root.querySelectorAll('.tm-stage');
    Array.prototype.forEach.call(stages, function (stage) {
      var track = stage.querySelector('.tm-track');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.tm-card'));
      var total = cards.length;
      if (!total) return;
      var current = 0;
      var autoTimer = null;
      var speed = parseFloat(stage.getAttribute('data-autoplay') || '2') * 1000;

      function update() {
        var prev = (current - 1 + total) % total;
        var next = (current + 1) % total;
        cards.forEach(function (card, i) {
          if (i === current) card.dataset.state = 'active';
          else if (total > 1 && i === prev) card.dataset.state = 'prev';
          else if (total > 2 && i === next) card.dataset.state = 'next';
          else card.dataset.state = 'hidden';
        });
      }
      function go(dir) {
        current = (current + dir + total) % total;
        update();
        resetTimer();
      }
      function resetTimer() {
        if (autoTimer) {
          clearInterval(autoTimer);
          var k = self.intervals.indexOf(autoTimer);
          if (k !== -1) self.intervals.splice(k, 1);
        }
        if (speed > 0 && total > 1) {
          autoTimer = setInterval(function () { go(1); }, speed);
          self.intervals.push(autoTimer);
        }
      }

      stage.addEventListener('click', function (e) {
        var btn = e.target.closest('.tm-arrow');
        if (btn) { go(btn.classList.contains('tm-prev') ? -1 : 1); return; }
        var card = e.target.closest('.tm-card');
        if (!card) return;
        if (card.dataset.state === 'prev') go(-1);
        else if (card.dataset.state === 'next') go(1);
      });

      update();
      resetTimer();
    });
  };

  /* ====== SUMMARY ====== */
  HoneyPeakQuiz.prototype.startSummaryLoading = function (step) {
    var self = this;
    var load = step.querySelector('[data-hpq-summary-loading]');
    var content = step.querySelector('[data-hpq-summary-content]');
    var bar = step.querySelector('[data-hpq-summary-bar]');
    var pct = step.querySelector('[data-hpq-summary-pct]');
    var dec = step.querySelector('.decline-bars');
    if (!load || !content) return;
    load.style.display = 'block';
    content.style.display = 'none';
    if (bar) bar.style.width = '0%';
    if (dec) dec.classList.remove('grow');
    this.later(function () { if (bar) bar.style.width = '100%'; }, 50);

    if (pct) {
      pct.textContent = '0%';
      var startPct = null;
      var stepPct = function (now) {
        if (startPct === null) startPct = now;
        var p = Math.min((now - startPct) / 2200, 1);
        pct.textContent = Math.round(easeOutCubic(p) * 100) + '%';
        if (p < 1) requestAnimationFrame(stepPct);
        else pct.textContent = '100%';
      };
      requestAnimationFrame(stepPct);
    }

    this.later(function () {
      load.style.display = 'none';
      content.style.display = 'flex';
      self.animateSummaryLevel(step);
      if (dec) { void dec.offsetWidth; requestAnimationFrame(function () { dec.classList.add('grow'); }); }
    }, 2400);
  };

  HoneyPeakQuiz.prototype.animateSummaryLevel = function (step) {
    var slider = step.querySelector('[data-hpq-level-slider]');
    if (!slider) return;
    var label = step.querySelector('[data-hpq-level-label]');
    var scoreNum = step.querySelector('[data-hpq-score]');
    var min = parseFloat(slider.getAttribute('data-min'));
    var max = parseFloat(slider.getAttribute('data-max'));
    if (isNaN(min)) min = 10;
    if (isNaN(max)) max = 18;
    if (max < min) { var tmp = min; min = max; max = tmp; }

    /* Lands somewhere between the min and max set in the theme editor */
    var target = Math.round((min + Math.random() * (max - min)) * 10) / 10;
    var startLeft = '4%';
    var fromPct = 4;
    var toPct = Math.round(target);
    slider.style.transition = 'none';
    slider.style.left = startLeft;
    if (label) { label.style.transition = 'none'; label.style.left = startLeft; }
    if (scoreNum) scoreNum.textContent = fromPct;
    void slider.offsetWidth; /* reflow so the reset sticks */
    requestAnimationFrame(function () {
      var ease = 'left 1.7s cubic-bezier(0.22, 1, 0.36, 1)';
      slider.style.transition = ease;
      slider.style.left = target + '%';
      if (label) { label.style.transition = ease; label.style.left = target + '%'; }
      if (scoreNum) {
        var startS = null;
        var stepS = function (now) {
          if (startS === null) startS = now;
          var p = Math.min((now - startS) / 1700, 1);
          var eased = 1 - Math.pow(1 - p, 4);
          scoreNum.textContent = Math.round(fromPct + (toPct - fromPct) * eased);
          if (p < 1) requestAnimationFrame(stepS);
          else scoreNum.textContent = toPct;
        };
        requestAnimationFrame(stepS);
      }
    });
  };

  /* ====== PLAN CHART ====== */
  HoneyPeakQuiz.prototype.startChartGrow = function (step) {
    var bars = step.querySelector('.chart-bars');
    if (!bars) return;
    bars.classList.remove('grow');
    void bars.offsetWidth; /* reflow so bars reset to 0 before growing */
    requestAnimationFrame(function () { bars.classList.add('grow'); });
  };

  /* ====== LOADING + POPUPS ====== */
  HoneyPeakQuiz.prototype.startLoadingSequence = function (step) {
    this.loadingStep = step;
    this.loadingPhase = 0;
    var heading = step.querySelector('.loading-heading');
    if (heading && heading.getAttribute('data-default')) heading.textContent = heading.getAttribute('data-default');
    var items = step.querySelectorAll('.loading-step-item');
    for (var i = 0; i < items.length; i++) {
      items[i].classList.remove('visible');
      var st = items[i].querySelector('.loading-step-status');
      if (st) st.innerHTML = '';
      var nm = items[i].querySelector('.loading-step-name');
      if (nm) nm.textContent = items[i].getAttribute('data-label') || '';
    }
    var bar = step.querySelector('[data-hpq-loading-bar]');
    if (bar) bar.style.width = '0%';
    this.runLoadingPhase(0);
  };

  HoneyPeakQuiz.prototype.runLoadingPhase = function (phase) {
    var self = this;
    var step = this.loadingStep;
    if (!step || !step.classList.contains('active')) return;
    var items = step.querySelectorAll('.loading-step-item');
    var bar = step.querySelector('[data-hpq-loading-bar]');
    var total = items.length;
    if (phase >= total) {
      if (bar) bar.style.width = '100%';
      var h = step.querySelector('.loading-heading');
      var ready = h && h.getAttribute('data-ready');
      if (ready) h.textContent = ready;
      this.later(function () { self.submit(); }, 800);
      return;
    }
    var item = items[phase];
    item.classList.add('visible');
    var status = item.querySelector('.loading-step-status');
    if (status) status.textContent = '50%';
    if (bar) bar.style.width = Math.floor(((phase + 1) * 99) / total) + '%';
    var question = item.getAttribute('data-question');
    this.later(function () {
      if (question) self.showModal(question, phase);
      else { self.loadingPhase = phase; self.completePhase(); }
    }, 1200);
  };

  HoneyPeakQuiz.prototype.showModal = function (text, phase) {
    if (!this.modal || !this.loadingStep || !this.loadingStep.classList.contains('active')) return;
    if (this.modalText) this.modalText.textContent = text;
    this.modal.classList.add('active');
    this.loadingPhase = phase;
  };

  HoneyPeakQuiz.prototype.closeModal = function () {
    if (this.modal) this.modal.classList.remove('active');
    this.completePhase();
  };

  HoneyPeakQuiz.prototype.completePhase = function () {
    var self = this;
    var step = this.loadingStep;
    if (!step) return;
    var phase = this.loadingPhase;
    var item = step.querySelectorAll('.loading-step-item')[phase];
    if (item) {
      var nm = item.querySelector('.loading-step-name');
      if (nm) nm.textContent = item.getAttribute('data-done') || item.getAttribute('data-label') || '';
      var st = item.querySelector('.loading-step-status');
      if (st) st.innerHTML = '<span class="loading-step-check">&#10003;</span>';
    }
    this.later(function () { self.runLoadingPhase(phase + 1); }, 600);
  };

  /* ====== INIT + THEME EDITOR SUPPORT ====== */
  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-hpq]');
    Array.prototype.forEach.call(roots, function (root) {
      var key = root.getAttribute('data-section-id') || 'default';
      if (instances[key] && instances[key].root === root) return;
      if (instances[key]) instances[key].destroy();
      instances[key] = new HoneyPeakQuiz(root);
    });
  }

  function instanceFor(target) {
    var root = target && target.closest ? target.closest('[data-hpq]') : null;
    if (!root) return null;
    return instances[root.getAttribute('data-section-id') || 'default'] || null;
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-hpq]');
    if (!root) return;
    var key = root.getAttribute('data-section-id') || 'default';
    if (instances[key]) { instances[key].destroy(); delete instances[key]; }
  });
  /* Selecting a step (block) in the theme editor jumps the preview to that step */
  document.addEventListener('shopify:block:select', function (e) {
    var inst = instanceFor(e.target);
    if (!inst) return;
    var step = e.target.closest('[data-hpq-step]');
    var idx = inst.steps.indexOf(step);
    if (idx === -1) return;
    inst.history = idx > 0 ? [0, idx] : [0];
    inst.show(idx, false);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();